/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getPatientIdentifierTypes } from 'app/entities/patient-identifier-type/patient-identifier-type.reducer';
import { createEntity, getEntity, reset, updateEntity } from './patient-identifier.reducer';

export const PatientIdentifierUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const patientIdentifierTypes = useAppSelector(state => state.patientIdentifierType.entities);
  const patientIdentifierEntity = useAppSelector(state => state.patientIdentifier.entity);
  const loading = useAppSelector(state => state.patientIdentifier.loading);
  const updating = useAppSelector(state => state.patientIdentifier.updating);
  const updateSuccess = useAppSelector(state => state.patientIdentifier.updateSuccess);

  const handleClose = () => {
    navigate(`/patient-identifier${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getGlucoUsers({}));
    dispatch(getPatientIdentifierTypes({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...patientIdentifierEntity,
      ...values,
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
      identifierType: patientIdentifierTypes.find(it => it.id.toString() === values.identifierType?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...patientIdentifierEntity,
          patient: patientIdentifierEntity?.patient?.id,
          identifierType: patientIdentifierEntity?.identifierType?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.patientIdentifier.home.createOrEditLabel" data-cy="PatientIdentifierCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.patientIdentifier.home.createOrEditLabel">Create or edit a PatientIdentifier</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="patient-identifier-id"
                  label={translate('tinyMedicRestApp.patientIdentifier.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.patientIdentifier.identifier')}
                id="patient-identifier-identifier"
                name="identifier"
                data-cy="identifier"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientIdentifier.provider')}
                id="patient-identifier-provider"
                name="provider"
                data-cy="provider"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientIdentifier.preferred')}
                id="patient-identifier-preferred"
                name="preferred"
                data-cy="preferred"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientIdentifier.microSec')}
                id="patient-identifier-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientIdentifier.timestampentry')}
                id="patient-identifier-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientIdentifier.lastupdated')}
                id="patient-identifier-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientIdentifier.cursor')}
                id="patient-identifier-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientIdentifier.active')}
                id="patient-identifier-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientIdentifier.verified')}
                id="patient-identifier-verified"
                name="verified"
                data-cy="verified"
                check
                type="checkbox"
              />
              <ValidatedField
                id="patient-identifier-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.patientIdentifier.patient')}
                type="select"
                required
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="patient-identifier-identifierType"
                name="identifierType"
                data-cy="identifierType"
                label={translate('tinyMedicRestApp.patientIdentifier.identifierType')}
                type="select"
                required
              >
                <option value="" key="0" />
                {patientIdentifierTypes
                  ? patientIdentifierTypes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/patient-identifier" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PatientIdentifierUpdate;
